const jwt_claims = {
    title: 'JWT المخصص',
    description: 'تخصيص رمز الوصول أو رمز الهوية، لتوفير معلومات إضافية لتطبيقك.',
    access_token: {
        card_title: 'رمز الوصول',
        card_description: 'رمز الوصول هو البيانات المستخدمة من قبل واجهات برمجة التطبيقات لتفويض الطلبات، ويحتوي فقط على المطالبات الضرورية لقرارات الوصول.',
    },
    user_jwt: {
        card_field: 'رمز الوصول للمستخدم',
        card_description: 'إضافة بيانات محددة للمستخدم أثناء إصدار رمز الوصول.',
        for: 'للمستخدم',
    },
    machine_to_machine_jwt: {
        card_field: 'رمز الوصول من الآلة إلى الآلة',
        card_description: 'إضافة بيانات إضافية أثناء إصدار رمز الوصول من الآلة إلى الآلة.',
        for: 'للآلة إلى الآلة',
    },
    id_token: {
        card_title: 'رمز الهوية',
        card_description: 'رمز الهوية هو تأكيد للهوية يتم استلامه بعد تسجيل الدخول، ويحتوي على مطالبات هوية المستخدم ليستخدمها العميل في العرض أو إنشاء الجلسة.',
        card_field: 'رمز هوية المستخدم',
        card_field_description: "المطالبات 'sub' و'email' و'phone' و'profile' و'address' متاحة دائمًا. يجب تمكين المطالبات الأخرى هنا أولاً. في جميع الحالات، يجب أن يطلب تطبيقك النطاقات المطابقة أثناء التكامل لاستلامها.",
    },
    code_editor_title: 'تخصيص مطالبات {{token}}',
    custom_jwt_create_button: 'إضافة مطالبات مخصصة',
    custom_jwt_item: 'مطالبات مخصصة {{for}}',
    delete_modal_title: 'حذف المطالبات المخصصة',
    delete_modal_content: 'هل أنت متأكد أنك تريد حذف المطالبات المخصصة؟',
    clear: 'مسح',
    cleared: 'تم المسح',
    restore: 'استعادة الافتراضيات',
    restored: 'تمت الاستعادة',
    data_source_tab: 'مصدر البيانات',
    error_handling_tab: 'معالجة الأخطاء',
    test_tab: 'سياق الاختبار',
    jwt_claims_description: 'المطالبات الافتراضية مضمنة تلقائيًا في JWT ولا يمكن استبدالها.',
    user_data: {
        title: 'بيانات المستخدم',
        subtitle: 'استخدم معلمة الإدخال `context.user` لتوفير معلومات المستخدم الحيوية.',
    },
    grant_data: {
        title: 'بيانات المنحة',
        subtitle: 'استخدم معلمة الإدخال `context.grant` لتوفير معلومات المنحة الحيوية، متاحة فقط لتبادل الرموز.',
    },
    interaction_data: {
        title: 'سياق تفاعل المستخدم',
        subtitle: 'استخدم المعلمة `context.interaction` للوصول إلى تفاصيل تفاعل المستخدم في جلسة المصادقة الحالية.',
    },
    application_data: {
        title: 'سياق التطبيق',
        subtitle: 'استخدم معامل الإدخال `context.application` لتوفير معلومات التطبيق المرتبطة بالرمز المميز.',
    },
    token_data: {
        title: 'بيانات الرمز',
        subtitle: 'استخدم معلمة الإدخال `token` لحمولة رمز الوصول الحالي.',
    },
    api_context: {
        title: 'سياق API: التحكم في الوصول',
        subtitle: 'استخدم طريقة `api.denyAccess` لرفض طلب الرمز.',
    },
    error_handling: {
        title: 'معالجة الأخطاء',
        subtitle: 'تحكم فيما إذا كان يجب حظر إصدار الرمز عند فشل السكربت.',
        input_field_title: 'سلوك إصدار الرمز عند حدوث خطأ في السكربت',
        block_issuance_switch: 'حظر إصدار الرمز عندما يواجه السكربت خطأ',
        default_hint_create: 'تستخدم نصوص المطالبات المخصصة الجديدة افتراضيًا حظر إصدار الرمز عند فشل البرنامج النصي. إذا كانت واجهة API تعيد قيمة بالفعل، فسيتم استخدام القيمة المحفوظة بدلًا من ذلك.',
        default_hint_edit: 'تحافظ نصوص المطالبات المخصصة الحالية التي لا تحتوي على هذا الإعداد على السلوك القديم بإيقاف الحظر افتراضيًا حتى تحفظ قيمة بشكل صريح.',
        warning: 'عند التفعيل، تؤدي أخطاء وقت تشغيل السكربت إلى رفض طلب الرمز باستخدام `invalid_request` (400) مع `error_description` مترجم. وتبقى استدعاءات `api.denyAccess` تُرجع `access_denied`.',
    },
    fetch_external_data: {
        title: 'استرجاع البيانات الخارجية',
        subtitle: 'دمج البيانات من واجهات برمجة التطبيقات الخارجية مباشرة في المطالبات.',
        description: 'استخدم وظيفة `fetch` لاستدعاء واجهات برمجة التطبيقات الخارجية الخاصة بك وتضمين البيانات في المطالبات المخصصة الخاصة بك. مثال: ',
    },
    environment_variables: {
        title: 'تعيين متغيرات البيئة',
        subtitle: 'استخدم متغيرات البيئة لتخزين المعلومات الحساسة.',
        input_field_title: 'إضافة متغيرات البيئة',
        sample_code: 'الوصول إلى متغيرات البيئة في معالج المطالبات JWT المخصص الخاص بك. مثال: ',
    },
    jwt_claims_hint: 'قم بتقييد المطالبات المخصصة إلى أقل من 50 كيلوبايت. المطالبات الافتراضية في JWT مضمنة تلقائيًا في الرمز ولا يمكن استبدالها.',
    tester: {
        subtitle: 'ضبط رمز وبيانات المستخدم الوهمية للاختبار.',
        run_button: 'تشغيل الاختبار',
        result_title: 'نتيجة الاختبار',
    },
    form_error: {
        invalid_json: 'تنسيق JSON غير صالح',
    },
};
export default Object.freeze(jwt_claims);
